var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallInfoIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.95 33C29.8667 33 27.8083 32.546 25.775 31.638C23.7417 30.73 21.8917 29.4423 20.225 27.775C18.5583 26.1077 17.271 24.2577 16.363 22.225C15.455 20.1923 15.0007 18.134 15 16.05C15 15.75 15.1 15.5 15.3 15.3C15.5 15.1 15.75 15 16.05 15H20.1C20.3333 15 20.5417 15.0793 20.725 15.238C20.9083 15.3967 21.0167 15.584 21.05 15.8L21.7 19.3C21.7333 19.5667 21.725 19.7917 21.675 19.975C21.625 20.1583 21.5333 20.3167 21.4 20.45L18.975 22.9C19.3083 23.5167 19.704 24.1123 20.162 24.687C20.62 25.2617 21.1243 25.816 21.675 26.35C22.1917 26.8667 22.7333 27.346 23.3 27.788C23.8667 28.23 24.4667 28.634 25.1 29L27.45 26.65C27.6 26.5 27.796 26.3877 28.038 26.313C28.28 26.2383 28.5173 26.2173 28.75 26.25L32.2 26.95C32.4333 27.0167 32.625 27.1377 32.775 27.313C32.925 27.4883 33 27.684 33 27.9V31.95C33 32.25 32.9 32.5 32.7 32.7C32.5 32.9 32.25 33 31.95 33Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallInfoIconBlack);
export default __webpack_public_path__ + "static/media/call-info-icon-black.4aec2748938d51a9ae0532248d475d0a.svg";
export { ForwardRef as ReactComponent };